import { useInput } from "react-admin";
import moment from "moment";
import "moment/locale/pt-br";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

// Campo de data moderno (calendário do MUI X — o mesmo do painel
// "Filtro de Datas" da lista de Sócios), compatível com formulários e
// filtros do react-admin via useInput.
//
// ⚠️ Sem regressão por construção: por padrão o valor no fio continua a
// string "YYYY-MM-DD" — exatamente o que o DateInput nativo/filtro enviava
// — então backend, filtros salvos e URLs não mudam. Formulários que gravam
// data "sem hora" (ex.: nascimento) passam {...dateOnlyProps} (format +
// parse) para manter o meio-dia UTC que evita o recuo de um dia na
// reexibição. Só a experiência muda: DD/MM/AAAA e navegação por ano/mês.
export const AppDateInput = ({
  source,
  label,
  fullWidth = true,
  format,
  parse,
  openTo,
  views,
}: {
  source: string;
  label?: string;
  fullWidth?: boolean;
  // Convertem entre o valor gravado no formulário e o "YYYY-MM-DD" do
  // calendário — a mesma dupla que o DateInput do react-admin usa.
  format?: (value: any) => string;
  parse?: (value: any) => any;
  // Abertura/visões do calendário (nascimento abre no ano p/ não paginar
  // décadas). Ausentes = padrão do MUI (dia).
  openTo?: "year" | "month" | "day";
  views?: Array<"year" | "month" | "day">;
}) => {
  const { field } = useInput({ source });
  const display = format ? format(field.value) : field.value;
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
      <DatePicker
        label={label}
        value={display ? moment(display, "YYYY-MM-DD") : null}
        onChange={(v: any) => {
          const ymd = v && v.isValid() ? v.format("YYYY-MM-DD") : "";
          field.onChange(parse ? parse(ymd) : ymd);
        }}
        format="DD/MM/YYYY"
        openTo={openTo}
        views={views}
        slotProps={{
          textField: {
            variant: "filled",
            fullWidth,
            helperText: false,
          },
          // Sem `field.clearable`: só existe a partir do MUI X 6.16 (aqui
          // é 6.12). Para limpar: apagar o texto ou remover o filtro no ⊗.
        }}
      />
    </LocalizationProvider>
  );
};
